import React, { useState, useEffect } from "react";

const Timer = ({ endAt, onEnd }) => {
  const [remaining, setRemaining] = useState(() => Math.max(0, Math.floor((endAt - Date.now()) / 1000)));

  useEffect(() => {
    if (remaining <= 0) {
      if (onEnd) onEnd();
      return;
    }
    const interval = setInterval(() => {
      const timeLeft = Math.max(0, Math.floor((endAt - Date.now()) / 1000));
      setRemaining(timeLeft);
      if (timeLeft <= 0) {
        clearInterval(interval);
        if (onEnd) onEnd();
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [endAt, remaining, onEnd]);

  if (remaining <= 0) return null;

  const mins = String(Math.floor(remaining / 60)).padStart(2, "0");
  const secs = String(remaining % 60).padStart(2, "0");

  return (
    <span>
      {mins}:{secs}
    </span>
  );
};

export default Timer;
